/**
 * PLAYER module — named tuning constants. Owned by PLAYER; see CONTRACTS.md.
 * World-coordinate conventions live in core/constants — never duplicated here.
 */

/** Walk speed in meters per second. */
export const WALK_SPEED = 3.2

/** Player collision capsule radius, meters. */
export const CAPSULE_RADIUS = 0.35
/** Player collision capsule height (feet to top of head), meters. */
export const CAPSULE_HEIGHT = 1.8
/** Iterations of push-out resolution per fixed step. */
export const COLLISION_ITERATIONS = 3

/** Radians of look rotation per pixel of mouse movement. */
export const MOUSE_SENSITIVITY = 0.0022

// --- Touch input scheme (coarse-pointer devices) -----------------------------
/** Multiplier on raw touch-drag px before the shared mouse-sensitivity path —
 * thumbs sweep less distance than a mouse for the same intended turn. */
export const TOUCH_LOOK_SENSITIVITY = 2.4
/** Fraction of viewport width (from the left) that anchors the joystick. */
export const JOYSTICK_ZONE_FRACTION = 0.45
/** Joystick travel radius, px — full deflection at the ring's edge. */
export const JOYSTICK_RADIUS_PX = 56
/** Deflection below this fraction is ignored (resting-thumb jitter). */
export const JOYSTICK_DEAD_ZONE = 0.15
/** A look-side touch this short and still is a tap → interact. */
export const TAP_MAX_DURATION_MS = 300
export const TAP_MAX_TRAVEL_PX = 12

/** Pitch clamp just shy of straight up/down to avoid gimbal flip. */
export const PITCH_LIMIT = Math.PI / 2 - 0.05

/** Center-screen interaction raycast reach, meters. */
export const INTERACT_MAX_DISTANCE = 2.5
/** Fallback InteractTarget.radius when the mesh does not provide one. */
export const DEFAULT_INTERACT_RADIUS = 1.5
/** Highlight outline color for the hovered interactable (noir amber). */
export const HIGHLIGHT_COLOR = 0xd8b860

/** Minimum seconds between throttled 'player:moved' emissions while walking. */
export const MOVED_EMIT_INTERVAL = 0.1
/** Seconds between re-scans of the scene for solid/interactable meshes. */
export const SCENE_CACHE_REFRESH_INTERVAL = 1
